<template>
  <div class="nav">
    <ul class="nav-list clearfix">
      <li class="nav-item">
        <a class="nav-a" href="//ffbewotv.seayoo.com/home/index.html">首页</a>
      </li>
      <li
        v-for="(menu, idx) in menuList"
        :key="menu.enName"
        class="nav-item"
        @click="moveFullTo(idx + 2)"
      >
        <a class="nav-a">{{ menu.name }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "NavBar",
  data: () => ({
    menuList: [
      { name: "阿多拉资讯", enName: "NEWS" },
      { name: "故事", enName: "STORY" },
      { name: "角色情报", enName: "CHARACTER" },
      { name: "影音鉴赏", enName: "VIDEO&MUSIC" },
      { name: "攻略站", enName: "WIKI" }
    ]
  }),
  computed: {
    ...mapState(["curTab"])
  },
  methods: {
    ...mapActions(["changeCurTab"]),
    moveFullTo(idx) {
      if (idx === 2) {
        if (location.hash !== "#/news") {
          this.$router.push({ path: "/news" });
        }
        return;
      }
      if (idx === 6) {
        window.location.href = "https://wotvwiki.kingsoft.com/";
        return;
      }
      this.$emit("moveTo", idx);
    }
  }
};
</script>
<style lang="less" scoped>
// @import "../assets/css/base.common.less";
@import "../assets/css/mixin.less";
.nav {
  .mixin_com(height, 75);

  overflow: hidden;
  background: url("~@/assets/images/navmask.png") repeat-x left top / contain;
  .nav-list {
    position: absolute;
    .mixin_com(top, 24);
    .mixin_com(right, 40);
    .mixin_com(width, 616);
    .mixin_com(height, 33);
    .mixin_com(font-size, 20);
    .transition(0.3s);
  }
  .nav-item {
    float: left;
    height: 100%;
    .mixin_com(margin-right, 40);

    cursor: pointer;
    a {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      background: url("~@/assets/images/ntxt.png?10") no-repeat 0 0;
      .mixin_bg_size(634, 33);

      transition: all 0.1s;
      &:hover {
        background-image: url("~@/assets/images/ntxt2.png?10");
      }
    }
    &:nth-child(1) {
      .mixin_com(width, 44);
      a {
        background-position: 0 0;
      }
    }
    &:nth-child(2) {
      .mixin_com(width, 98);
      a {
        .mixin_com(background-position-x, -86);
      }
    }
    &:nth-child(3) {
      .mixin_com(width, 50);
      a {
        .mixin_com(background-position-x, -232);
      }
    }
    &:nth-child(4) {
      .mixin_com(width, 78);
      a {
        .mixin_com(background-position-x, -333);
      }
    }
    &:nth-child(5) {
      .mixin_com(width, 85);
      a {
        .mixin_com(background-position-x, -451);
      }
    }
    &:nth-child(6) {
      .mixin_com(width, 60);

      margin-right: 0;
      a {
        .mixin_com(background-position-x, -573);
      }
    }
  }
  .nav-a {
    display: block;
    .mixin_com(font-size, 20);

    color: #d2d2d2;
    text-indent: -9999px;
  }
  .nav-item-en {
    display: block;
    .mixin_com(font-size, 10);

    color: #999;
    .mixin_com(letter-spacing, 2);
  }
}
</style>
